import { render, staticRenderFns } from "./Trams.vue?vue&type=template&id=54febe59&scoped=true&"
import script from "./Trams.vue?vue&type=script&lang=js&"
export * from "./Trams.vue?vue&type=script&lang=js&"
import style0 from "./Trams.vue?vue&type=style&index=0&id=54febe59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54febe59",
  null
  
)

export default component.exports